<template>
    <div>
        <div class="topDialog">
            <el-dialog title="推荐商品" :visible.sync="recommendGoodsDialog"  :close-on-click-modal="false">
            <span class="dialogTitle">*同类商品最多可选10个,人气商品最多可选20个</span>
            <div class="searchTop">
                        <div class="searchItem">
                            <div class="name">商品名称</div>
                            <el-input placeholder="请输入" v-model="goodsForm.name"></el-input>
                        </div>
                        <div class="searchItem">
                            <div class="name">商家名称</div>
                            <el-input placeholder="请输入" v-model="goodsForm.storeName"></el-input>
                        </div>
                        <div class="searchItem">
                            <el-button class="searchBtn" @click="search">搜索</el-button>
                            <el-button type="text" class="resetBtn" @click="resetData">
                                <i class="iconfont icon-qingchushujuku"></i>
                                <span>清除条件</span>
                            </el-button>
                        </div>
                </div>
                    <div class="list">
                    <div style="width:45%">
                        <div class="goodsList">商品列表</div>
                        <el-table :data="goodsTableData" :header-cell-style="{'text-align':'center','background':'rgba(242, 242, 242, 1)'}"  :cell-style="{textAlign:'center'}">
                        <el-table-column property="goodsInfo" label="商品名称" width="260">
                            <template slot-scope="scope">
                            <div v-for="(item,index) in scope.row.goodsInfo" :key="index" class="goodsImg">
                                    <img :src="item.img" alt="" style="width:50px">
                                    <span style="width:124px">{{item.name}}</span>
                            </div>

                            </template>
                        </el-table-column>
                        <el-table-column property="storeName" label="商家名称" width="200" style="text-align:left" show-overflow-tooltip></el-table-column>
                        <el-table-column property="address" label="操作">
                        <template slot-scope="scope">
                            <el-button size="mini" v-if="!scope.row.isRecommendBySystem" type="text" @click="add(scope.row)">添加</el-button>
                             <el-button size="mini" type="text"  style="color:gray" v-if="scope.row.isRecommendBySystem">已添加</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>

                    <div style="width:50%">
                        <div class="goodsList">推荐列表</div>
                        <el-table :data="recommendedGoodsTableData" :header-cell-style="{'text-align':'center','background':'rgba(242, 242, 242, 1)'}"  :cell-style="{textAlign:'center'}">
                        <el-table-column property="goodsInfo" label="商品名称" width="260">
                            <template slot-scope="scope">
                                <div v-for="(item,index) in scope.row.goodsInfo" :key="index" class="goodsImg">
                                    <img :src="item.img" alt="" style="width:50px">
                                    <span style="width:180px">{{item.name}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column property="storeName" label="商家名称" width="180" style="text-align:left" show-overflow-tooltip></el-table-column>
                        <el-table-column property="sort" label="排序" width="80" style="text-align:left"></el-table-column>
                        <el-table-column property="address" label="操作">
                            <template slot-scope="scope">
                                <el-button size="mini" type="text" @click="remove(scope.$index, scope.row)">移除</el-button>
                                <el-button size="mini" type="text" @click="sortGoods(scope.row)">排序</el-button>
                            </template>
                        </el-table-column>
                        </el-table>
                    </div>
                </div>
                        <div style="text-align:center" class="btn">
                            <el-button type="primary" @click="saveRecommendGoods">保存</el-button>
                            <el-button plain @click="recommendGoodsDialog=false">取消</el-button>
                        </div>
            </el-dialog>
        </div>
        <!-- 排序弹窗框 -->
        <el-dialog title="排序" :visible.sync="sortDialogVisible" :close-on-click-modal="false">
            <el-form>
                <el-form-item label="排序">
                    <el-input-number v-model="sortNo" :min="1" style="width:200px"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="sortDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="changeSortNo">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {getRecommendGoodsList, saveRecommendGoods, modifyRecommendGoodsOrder, getRecommendGoodsListByPlatformFirstTypeUuid} from "../../../../utils/interface";
    export default {
    data(){
      return{
          sortDialogVisible: false,
          sortNo: null,
          goodsUuid: null,
          recommendUuid: null,
          platformFirstTypeUuid: null,
         current:1,
        total: 0,
        pageSize: 8,
        input:"",
        recommendGoodsDialog:false,
          goodsForm:{name:'',storeName:''},
          recommendedGoodsForm:{},
         goodsTableData: [],
          recommendedGoodsTableData: [],
          recommendName: '',
      }
    },

    methods:{
       init(type,recommendClass) {
           this.goodsTableData = [];
           this.recommendedGoodsTableData = [];
            this.recommendGoodsDialog = true;
            this.recommendUuid = recommendClass.uuid;
            this.recommendName = recommendClass.goodsRecommend;
            this.platformFirstTypeUuid = recommendClass.goodsRecommendUuid;
           this.search();
           this.searchRecommended();
        },
        search(){
            this.goodsForm.platformFirstTypeUuid = this.platformFirstTypeUuid;
            this.goodsForm.status = 'SHELVE';
            this.goodsForm.current = this.current;
            this.goodsForm.pageSize = this.pageSize;
            this.goodsForm.recommendUuid = this.recommendUuid;
            getRecommendGoodsListByPlatformFirstTypeUuid(this.goodsForm).then((res)=>{
                this.goodsTableData = [];
                if(res != null && res.list != null && res.list.length > 0){
                    this.total = res.total;
                    res.list.forEach((item, index) => {
                        let goodsInfo = [];
                        goodsInfo.push({uuid:item.uuid, name:item.name, img:item.imgUrl == (null || '') ? require("../../../../assets/images/111111.jpeg") : item.imgUrl, });
                        let info = {goodsInfo : goodsInfo, storeName : item.storeName,status:"increase", isRecommendBySystem:item.isRecommendBySystem};
                        this.goodsTableData.push(info);
                        // console.log(this.goodsTableData)
                    });
                }else{
                    this.total = 0;
                }
            });
        },
        searchRecommended(){
            this.recommendedGoodsForm.recommendUuid = this.recommendUuid;
            getRecommendGoodsList(this.recommendedGoodsForm).then((res)=>{
                this.recommendedGoodsTableData = [];
                if(res != null && res.length > 0){
                    res.forEach((item, index) => {
                        let goodsInfo = [];
                        goodsInfo.push({uuid:item.uuid, name:item.goodsName, goodsUuid:item.goodsUuid, recommendUuid:item.recommendUuid, img:item.imgUrl == null ? require("../../../../assets/images/111111.jpeg") : item.imgUrl});
                        let info = {goodsInfo : goodsInfo, sort:item.sort, storeName : item.storeName};
                        this.recommendedGoodsTableData.push(info);
                    });
                }
            });
        },
        // 分页
        handleCurrentChange(val){
            this.current = val;
            this.search();
        },
        resetData(){
            this.goodsForm.name = '';
            this.goodsForm.storeName = '';
        },
        add(obj){
           if(this.recommendedGoodsTableData.length > 9 && this.recommendName != '人气推荐'){
               this.$message.error("同类商品最多可推荐10个");
           }else if(this.recommendedGoodsTableData.length > 19 && this.recommendName == '人气推荐'){
                this.$message.error("人气推荐商品最多可推荐20个");
            }else{
               let goodsId = obj.goodsInfo[0].uuid;
               var index = this.recommendedGoodsTableData.findIndex(item =>{
                   if(item.goodsInfo[0].goodsUuid == goodsId){
                       this.$message.error("该商品已被设为推荐商品，无需重复设置");
                       return true
                   }
               })
               if(index == -1){
                   let goodsName = obj.goodsInfo[0].name;
                   let goodsUrl = obj.goodsInfo[0].img;
                   let goodsInfo = [];
                   goodsInfo.push({goodsUuid:goodsId, name:goodsName, img:goodsUrl == null ? require("../../../../assets/images/111111.jpeg") : goodsUrl});
                   let info = {goodsInfo : goodsInfo, storeName : obj.storeName, sort:99};
                   this.recommendedGoodsTableData.push(info);
                   this.goodsTableData.findIndex(item =>{
                       if(item.goodsInfo[0].uuid == obj.goodsInfo[0].uuid){
                           item.isRecommendBySystem = true;
                       }
                   })
               }

           }
        },
        remove(index, obj){
            this.goodsTableData.findIndex(item =>{
                if(item.goodsInfo[0].uuid == obj.goodsInfo[0].goodsUuid){
                    item.isRecommendBySystem = false;
                }
            })
            this.recommendedGoodsTableData.splice(index,1);
        },
        sortGoods(data){
            this.goodsUuid = data.goodsInfo[0].goodsUuid;
            this.sortNo = data.sort;
            this.sortDialogVisible=true;
        },
        //更改排序
        changeSortNo(){
            var numReg = /^[0-9]*$/
            var numRe = new RegExp(numReg)
            if (!numRe.test(this.sortNo)) {
                this.$message({
                    type: 'warning',
                    message: '请输入数字',
                    duration: 10000,
                    showClose: true,
                })
                return false
            }
            if(this.goodsUuid != ''){
                this.recommendedGoodsTableData.some(item =>{
                    if(item.goodsInfo[0].goodsUuid == this.goodsUuid){
                        item.sort = this.sortNo;
                        this.sortDialogVisible = false;
                        return true
                    }
                })
            }
        },
        saveRecommendGoods(){
           let goods = [];
           if(this.recommendedGoodsTableData.length > 0){
               this.recommendedGoodsTableData.forEach(item =>{
                   let goodsInfo = item.goodsInfo[0];
                   goods.push({goodsUuid: goodsInfo.goodsUuid, sort:item.sort});
               });
               saveRecommendGoods(this.recommendUuid,goods).then((res)=>{
                   if(res.success){
                       this.$message({
                           type: "success",
                           message: "保存成功",
                       });
                       this.recommendGoodsDialog = false;
                       this.$parent.search();
                   }else{
                       this.$message({
                           type: "error",
                           message: response.message,
                       });
                   }
               });
           }else{
               this.$message.error("您还未设置推荐商品，无法保存！");
           }


        }
    }
}
</script>

<style scoped lang="less">
 .searchTop {
      display: flex;
      margin-bottom: 22px;
      /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;
                }
            }
        .searchItem {
          display: flex;
          align-items: center;
          margin-right: 30px;
           .searchBtn {
                width: 82px;
                background-color: #3d7fff;
                border: none;
                color: white;
                font-size: 14px;
                border-radius: 15px;
            }

            .resetBtn {
                color: #000000;
            }
          .name {
             min-width: 80px;
              }
          }


  }
  .topDialog{
          /deep/.el-dialog{
            width: 90%;
            .dialogTitle{
              left: 107px;
              position: absolute;
              top: 23px;
              color: #409EFF;
            }

  }
.list{
  display: flex;
  justify-content: space-between;
}
.goodsImg{
  display: flex;
  align-items: center;
  justify-content: center;
  span{
    text-align: left;
    margin-left: 10px;
  }
}
.goodsList{
  width: 200px;
  margin-bottom: 20px;
}
  .pagination{
      text-align: right;
      margin-top: 20px;
      /deep/.el-input__inner{
        width: 46px;
        min-height: 28px!important;
      }
    }


            // /deep/ .el-range-editor {
            //     width: 500px;

            //     /deep/ .el-range-input {
            //         width: 242px;
            //         height: 32px;
            //         min-height: 32px;
            //         font-size: 12px;
            //         color: #999999;
            //         background-color: #f2f4f7;
            //     }

            //     /deep/ .el-range__icon,
            //     /deep/ .el-range-separator,
            //     /deep/ .el-range__close-icon {
            //         line-height: 29px;
            //     }

            //     &:hover,
            //     &:focus {
            //         background-color: #fff;
            //         border: 1px solid #108ee9;

            //         /deep/ .el-range-input {
            //             background-color: #fff;
            //         }
            //     }
            // }




     .btn{
       margin-top: 30px;
     }

}




</style>



// WEBPACK FOOTER //
// src/views/commodityManagement/category/dialog/recommendGoodsDialog.vue